/**
 * Layout sizing constants for the resizable / collapsible dashboard sidebars.
 * Widths clamp to [MIN, MAX]; below COLLAPSE_BREAKPOINT both sidebars auto-collapse.
 */
export const RULES_MIN = 220;
export const RULES_MAX = 480;
export const RULES_DEFAULT = 320;

export const ALERTS_MIN = 260;
export const ALERTS_MAX = 520;
export const ALERTS_DEFAULT = 360;

export const COLLAPSE_BREAKPOINT = 1100;
export const HANDLE_WIDTH = 6;

/** localStorage keys — persisted layout preferences. */
export const LS_RULES_W = 'soc.layout.rulesWidth';
export const LS_ALERTS_W = 'soc.layout.alertsWidth';
export const LS_RULES_COLLAPSED = 'soc.layout.rulesCollapsed';
export const LS_ALERTS_COLLAPSED = 'soc.layout.alertsCollapsed';
